import React from 'react';
import { useLanguage } from '../translations/LanguageContext';
import { practitioner } from '../mock/mockData';
import { Card } from './ui/card';
import { Award } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();
  
  return (
    <section id="about" className="py-20 px-4">
      <div className="container max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">{t.about.title}</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            {t.about.subtitle}
          </p>
        </div>

        <Card className="product-card">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src={practitioner.image}
                alt={t.about.name}
                className="w-full h-96 object-cover" />

            </div>
            
            <div>
              <h3 className="heading-3 mb-2">{t.about.name}</h3>
              <p className="body-medium text-accent-text mb-6">{t.about.practitionerTitle}</p>
              
              <p className="body-medium mb-6">{t.about.bio}</p>
              
              <div className="space-y-3">
                <div className="flex items-center gap-2 mb-3">
                  <Award className="text-accent-primary" size={20} />
                  <span className="body-medium font-semibold">{t.about.credentialsTitle}</span>
                </div>
                {t.about.credentials.map((credential, idx) => (
                  <div key={idx} className="flex items-start gap-2 pl-7">
                    <span className="text-accent-primary mt-1">•</span>
                    <span className="body-medium">{credential}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default About;
